import { Profile } from "./profile";
import { connect } from "react-redux";
import { actions } from "../../../actions/auth";

const mapDispatchToProps = {
  logoutAttempt: actions.logoutAttempt
};

export const ProfileContainer = connect(
  null,
  mapDispatchToProps
)(Profile);
